let _ = require('ES/lib/lodash');
let esUtils = require('ES/utils/esUtils');
let AuthedUserSession = require('../../../../../utils/AuthedUserSession');

let sids_I_can_manage = esUtils.cleanup_ids(_.flattenDeep([
	AuthedUserSession.doIHaveAccess.spkr.getSIDs(),
	AuthedUserSession.doIHaveAccess.admin.getSIDs()
]));

module.exports = function(Displaylists){
	return _.filter(Displaylists && Displaylists.perspeaker, function(spkr){
		return _.includes(sids_I_can_manage, spkr.sid);
	});
};



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/misc/getListOfSpeakersWhoCanEditMasterStoriesList.js